import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    items: [],    // { id, type, title, message, duration }
    maxItems: 5,
};

let nextId = 0;

const notificationSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        addNotification(state, action) {
            const notification = {
                id: nextId++,
                type: 'info', // 'success' | 'error' | 'warning' | 'info'
                duration: 5000,
                ...action.payload,
            };
            state.items.push(notification);
            // Keep only the max number of items
            if (state.items.length > state.maxItems) {
                state.items = state.items.slice(-state.maxItems);
            }
        },
        removeNotification(state, action) {
            state.items = state.items.filter((n) => n.id !== action.payload);
        },
        clearAllNotifications(state) {
            state.items = [];
        },
    },
});

export const {
    addNotification,
    removeNotification,
    clearAllNotifications,
} = notificationSlice.actions;

export const notificationReducer = notificationSlice.reducer;

// ─── Selectors ──────────────────────────────────────────────────────────────
export const selectNotifications = (state) => state.notifications.items;
export const selectHasNotifications = (state) => state.notifications.items.length > 0;
